// Central catalog of admin-assignable professional skills for SauberEko HoF.
// Keys are stable identifiers (do not translate) — used as DB values.
// Labels are per-locale display strings.

export const SKILL_GROUPS = [
  {
    id: "general",
    icon: "🔧",
    labels: { sk: "Všeobecné", en: "General", cs: "Obecné", de: "Allgemein", pl: "Ogólne", fr: "Général" },
    skills: [
      { id: "gen_pripravar", labels: { sk: "Prípravár", en: "Pipe fit-up", cs: "Přípravář", de: "Rohrvorbereitung", pl: "Przygotowywacz", fr: "Préparateur" } },
      { id: "gen_potrubar", labels: { sk: "Potrubár", en: "Pipefitter", cs: "Potrubář", de: "Rohrleger", pl: "Rurarz", fr: "Tuyauteur" } },
      { id: "gen_izo", labels: { sk: "Čítanie izometrie", en: "Isometric reading", cs: "Čtení izometrie", de: "Isometrie lesen", pl: "Czytanie izometrii", fr: "Lecture isométrique" } },
      { id: "gen_ohyb_maly", labels: { sk: "Ohýbanie malých priemerov rúr", en: "Small-diameter tube bending", cs: "Ohýbání malých průměrů trubek", de: "Kleinrohr-Biegen", pl: "Gięcie rur o małej średnicy", fr: "Cintrage de petits diamètres" } },
      { id: "gen_cleanroom", labels: { sk: "Clean room", en: "Clean room", cs: "Clean room", de: "Reinraum", pl: "Clean room", fr: "Salle blanche" } },
      { id: "gen_uhp", labels: { sk: "UHP standard", en: "UHP standard", cs: "UHP standard", de: "UHP-Standard", pl: "Standard UHP", fr: "Standard UHP" } },
      { id: "role_naborar", labels: { sk: "Náborár", en: "Recruiter", cs: "Náborář", de: "Personalvermittler", pl: "Rekruter", fr: "Recruteur" } },
    ],
  },
  {
    id: "tig_materials",
    icon: "🔥",
    labels: { sk: "TIG/WIG ručný — materiály", en: "Manual TIG/WIG — materials", cs: "TIG/WIG ruční — materiály", de: "TIG/WIG manuell — Werkstoffe", pl: "TIG/WIG ręczny — materiały", fr: "TIG/WIG manuel — matériaux" },
    skills: [
      { id: "tig_stainless", labels: { sk: "Nerez", en: "Stainless", cs: "Nerez", de: "Edelstahl", pl: "Stal nierdzewna", fr: "Inox" } },
      { id: "tig_aluminum", labels: { sk: "Hliník", en: "Aluminum", cs: "Hliník", de: "Aluminium", pl: "Aluminium", fr: "Aluminium" } },
      { id: "tig_carbon", labels: { sk: "Čierny materiál", en: "Carbon steel", cs: "Uhlíková ocel", de: "Kohlenstoffstahl", pl: "Stal węglowa", fr: "Čierny materiál" } },
      { id: "tig_titanium", labels: { sk: "Titán", en: "Titanium", cs: "Titan", de: "Titan", pl: "Tytan", fr: "Titane" } },
      { id: "tig_duplex", labels: { sk: "Duplex", en: "Duplex", cs: "Duplex", de: "Duplex", pl: "Duplex", fr: "Duplex" } },
    ],
  },
  {
    id: "orbital_devices",
    icon: "🤖",
    labels: { sk: "Orbitálny zvárač — zariadenia", en: "Orbital welder — devices", cs: "Orbitální svářeč — zařízení", de: "Orbitalschweißer — Geräte", pl: "Spawacz orbitalny — urządzenia", fr: "Orbitálny zvárač — zariadenia" },
    skills: [
      { id: "orb_orbitec", labels: { sk: "Orbitec", en: "Orbitec", cs: "Orbitec", de: "Orbitec", pl: "Orbitec", fr: "Orbitec" } },
      { id: "orb_axxair", labels: { sk: "Axxair", en: "Axxair", cs: "Axxair", de: "Axxair", pl: "Axxair", fr: "Axxair" } },
      { id: "orb_orbitalum", labels: { sk: "Orbitalum", en: "Orbitalum", cs: "Orbitalum", de: "Orbitalum", pl: "Orbitalum", fr: "Orbitalum" } },
      { id: "orb_polysoude", labels: { sk: "Polysoude", en: "Polysoude", cs: "Polysoude", de: "Polysoude", pl: "Polysoude", fr: "Polysoude" } },
      { id: "orb_ami", labels: { sk: "AMI", en: "AMI", cs: "AMI", de: "AMI", pl: "AMI", fr: "AMI" } },
    ],
  },
  {
    id: "languages",
    icon: "🌍",
    labels: { sk: "Jazyky", en: "Languages", cs: "Jazyky", de: "Sprachen", pl: "Języki", fr: "Langues" },
    skills: [
      { id: "lang_sk", labels: { sk: "🇸🇰 SK", en: "🇸🇰 SK", cs: "🇸🇰 SK", de: "🇸🇰 SK", pl: "🇸🇰 SK", fr: "🇸🇰 SK" } },
      { id: "lang_cs", labels: { sk: "🇨🇿 CZ", en: "🇨🇿 CZ", cs: "🇨🇿 CZ", de: "🇨🇿 CZ", pl: "🇨🇿 CZ", fr: "🇨🇿 CZ" } },
      { id: "lang_en", labels: { sk: "🇬🇧 EN", en: "🇬🇧 EN", cs: "🇬🇧 EN", de: "🇬🇧 EN", pl: "🇬🇧 EN", fr: "🇬🇧 EN" } },
      { id: "lang_de", labels: { sk: "🇩🇪 DE", en: "🇩🇪 DE", cs: "🇩🇪 DE", de: "🇩🇪 DE", pl: "🇩🇪 DE", fr: "🇩🇪 DE" } },
      { id: "lang_pl", labels: { sk: "🇵🇱 PL", en: "🇵🇱 PL", cs: "🇵🇱 PL", de: "🇵🇱 PL", pl: "🇵🇱 PL", fr: "🇵🇱 PL" } },
      { id: "lang_es", labels: { sk: "🇪🇸 ES", en: "🇪🇸 ES", cs: "🇪🇸 ES", de: "🇪🇸 ES", pl: "🇪🇸 ES", fr: "🇪🇸 ES" } },
      { id: "lang_it", labels: { sk: "🇮🇹 IT", en: "🇮🇹 IT", cs: "🇮🇹 IT", de: "🇮🇹 IT", pl: "🇮🇹 IT", fr: "🇮🇹 IT" } },
      { id: "lang_hu", labels: { sk: "🇭🇺 HU", en: "🇭🇺 HU", cs: "🇭🇺 HU", de: "🇭🇺 HU", pl: "🇭🇺 HU", fr: "🇭🇺 HU" } },
    ],
  },
];

// Flat lookup: skill-id → { groupId, labels, groupIcon }
const _flat = {};
SKILL_GROUPS.forEach((g) => g.skills.forEach((s) => {
  _flat[s.id] = { groupId: g.id, labels: s.labels, groupIcon: g.icon };
}));

export function skillLabel(id, lang = "sk") {
  const rec = _flat[id];
  if (!rec) return id;
  return rec.labels[lang] || rec.labels.sk || id;
}

export function groupSkillsByCategory(ids, lang = "sk") {
  const out = {};
  (ids || []).forEach((id) => {
    const rec = _flat[id];
    if (!rec) return;
    if (!out[rec.groupId]) out[rec.groupId] = { icon: rec.groupIcon, groupId: rec.groupId, items: [] };
    out[rec.groupId].items.push({ id, label: rec.labels[lang] || rec.labels.sk || id });
  });
  // stable order matching SKILL_GROUPS
  return SKILL_GROUPS.map((g) => out[g.id]).filter(Boolean);
}
